import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';
import { getPackageById } from "../../graphqlDic";
import { compose, graphql } from 'react-apollo';

class PurchasedPackage extends Component {

    generateResult = () => {
        let packageDetailId = this.props.match.params.package_detail_id;
        let packageItem = this.props.getPackageById.getPackageById;
        let packagesDetailIds = [...packageItem.package_details].map(item => item.id);
        let index = packagesDetailIds.indexOf(packageDetailId);
        let packageDetailSelected = null;
        if (index !== -1) {
            packageDetailSelected = packageItem.package_details[index];
            return `Bạn đã mua thành công gói ${packageItem.title} với giá ${packageDetailSelected.scoin} Scoin trong ${packageDetailSelected.day} ngày`;
        }
    }

    render() {
        if (this.props.getPackageById.loading) return 'PurchasedPackage Component loading...';
        if (this.props.getPackageById.error) return `PurchasedPackage Error: ${this.props.getPackageById.error.message}`;

        return (
            <div className="bg-black">
                <div className="select-bundle-vip">
                    <Container>
                        <Row>
                            <div className="col-xs-12 col-md-6 col-md-offset-3">
                                <div className="boxes">
                                    <div className="box past active">
                                        <div className="inner active">
                                            <div className="icon"><i className="fa fa-credit-card-alt fa-2x" aria-hidden="true"></i></div>
                                            <p>Chọn gói</p>
                                        </div>
                                    </div>
                                    <div className="box past active">
                                        <div className="inner active">
                                            <div className="icon"><i className="fa fa-credit-card fa-2x" aria-hidden="true"></i></div>
                                            <p>Thanh toán</p>
                                        </div>
                                    </div>
                                    <div className="box past">
                                        <div className="inner active">
                                            <div className="icon"><i className="fa fa-check-square-o fa-2x" aria-hidden="true"></i></div>
                                            <p>Hoàn thành</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="list-payment-types">
                                    <h1 className="scoin-title">Thông tin xác nhận</h1>
                                    <Row>
                                        <div className="col-xs-12 col-md-6 col-md-offset-3">
                                            <div className="confirm_info_block">
                                                <table className="table table-borderless">
                                                    <tbody>
                                                        <tr><th scope="row">Thông báo:</th><td><strong>{this.generateResult()}</strong></td></tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </Row>
                                </div>
                            </div>
                        </Row>
                    </Container >
                </div>
            </div>
        );
    }
}

export default compose(graphql(
    getPackageById, {
        name: 'getPackageById',
        options: (ownProps) => ({
            variables: {
                id: parseInt(ownProps.match.params.package_id, 10)
            }
        })
    })
)(PurchasedPackage);


// WEBPACK FOOTER //
// ./src/components/Scoin/PurchasedPackage.js